import { Link } from "react-router-dom";

export default function RefundPolicy() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-white">
      <div className="max-w-3xl w-full bg-white dark:bg-gray-800 p-8 md:p-12 rounded-lg shadow-lg">
        <h1 className="text-4xl font-bold text-center mb-6">Cancellation and Refunds</h1>
        <p className="text-lg text-center mb-6">
          At <span className="font-semibold">PrintKaro.shop</span>, we follow a strict{" "}
          <span className="font-semibold text-red-600 dark:text-red-400">
            No Refund, No Cancellation
          </span>{" "}
          policy.
        </p>

        <div className="space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mb-2">1. No Cancellation After Payment</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              • Once a print order is placed and payment is completed,{" "}
              <strong>it cannot be canceled.</strong>
              <br />• We start processing the print order <strong>immediately</strong>, so
              cancellation is not possible.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">2. No Refund Policy</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              • <strong>Refunds are not provided</strong> under any circumstances after payment.
              <br />• If the printout is defective due to our error, we will provide a{" "}
              <strong>reprint</strong> at no extra cost.
              <br />• Customers must <strong>carefully upload correct files</strong>, as we print
              exactly what is uploaded.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">3. Exceptions for Reprint</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              • If the printed document is <strong>damaged</strong> or <strong>incorrect</strong>{" "}
              due to a printing issue, we will offer a <strong>free reprint</strong>.<br />•
              Customers must <strong>contact us within 24 hours</strong> of pickup with proof of the
              issue.
              <br />• No refunds will be given, only reprints where applicable.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-2">4. Contact for Support</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              If you have any concerns about your print order, email us at{" "}
              <span className="font-semibold text-blue-600 dark:text-blue-400">
                printkaro369@gmail.com
              </span>{" "}
              or call{" "}
              <span className="font-semibold text-blue-600 dark:text-blue-400">
                +91 95606 34482
              </span>
              .
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-indigo-600 dark:text-indigo-400 hover:underline">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
